var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{ref:"chart",staticClass:"apex-charts",attrs:{"type":"bar","dir":"ltr","height":"360","series":_vm.series,"options":_vm.chartOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }